import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';

export type TimeEntry = {
  value: string;
  maxValue: number;
  minValue: number;
  onChange?: (value: string) => void;
  className?: string;
};

/**
 * @param props 時刻もしくは不正時は’0’文字を入力します
 * @returns
 */
const TimeEntry: React.FC<TimeEntry> = (props: TimeEntry) => {
  const [val, setVal] = useState<string>(props.value);

  useEffect(() => {
    //console.debug(['- useEffect - props.value', props.value]);
    setVal(props.value);
  }, [props.value]);

  //console.debug(['- 画面描画開始 -', val]);
  return (
    <TextField
      className={props.className}
      inputProps={{ style: { textAlign: 'right' } }}
      type="text"
      defaultValue={props.value}
      value={val}
      onChange={(event) => {
        const num = parseInt(event.target.value);
        console.debug(`onChange() val:${event.target.value} num:${num}`);

        if (!isNaN(num)) {
          if (props.minValue <= num && num <= props.maxValue) {
            //指定時間内
            setVal(num.toString());
            if (props.onChange) {
              props.onChange(num.toString());
            }
          }
        } else {
          console.debug(['-- NaN --', num]);
          setVal('0');
          if (props.onChange) {
            props.onChange('0');
          }
        }
      }}
      onFocus={(e) => e.target.select()}
    />
  );
};

export default TimeEntry;
